import i18n from '../../i18n';

const TED = 'TED';
const DOC = 'DOC';
const DINHEIRO = 'DINHEIRO';
const CHEQUE = 'CHEQUE';
const BOLETO = 'BOLETO';
const PIX = 'PIX';
const DEBITO_EM_CONTA = 'DEBITO_EM_CONTA';
const PAGAMENTO_REALIZADO = 'PAGAMENTO_REALIZADO';

const FORMA_PAGAMENTO_LIST = [
  {
    label: '1 - TED',
    value: TED,
  },
  {
    label: '2 - DOC',
    value: DOC,
  },
  {
    label: '3 - DINHEIRO',
    value: DINHEIRO,
  },
  {
    label: '4 - CHEQUE',
    value: CHEQUE,
  },
  {
    label: '5 - BOLETO',
    value: BOLETO,
  },
  {
    label: '6 - PIX',
    value: PIX,
  },
  {
    label: '7 - DÉBITO EM CONTA',
    value: DEBITO_EM_CONTA,
  },
  {
    label: '8 - PAGAMENTO REALIZADO',
    value: PAGAMENTO_REALIZADO,
  },
];

const isFormaPagamentoTED = (value) => TED === value;

const isFormaPagamentoDOC = (value) => DOC === value;
const isFormaPagamentoDinheiro = (value) => DINHEIRO === value;

const isFormaPagamentoCheque = (value) => CHEQUE === value;
const isFormaPagamentoBoleto = (value) => BOLETO === value;

const isFormaPagamentoPIX = (value) => PIX === value;
const isFormaPagamentoDebidoEmConta = (value) => DEBITO_EM_CONTA === value;

const FormaPagamentoUtils = Object.freeze({
  TED,
  DOC,
  DINHEIRO,
  CHEQUE,
  BOLETO,
  PIX,
  DEBITO_EM_CONTA,
  PAGAMENTO_REALIZADO,
  isTED: isFormaPagamentoTED,
  isDOC: isFormaPagamentoDOC,
  isDinheiro: isFormaPagamentoDinheiro,
  isCheque: isFormaPagamentoCheque,
  isBoleto: isFormaPagamentoBoleto,
  isPIX: isFormaPagamentoPIX,
  isDebidoEmConta: isFormaPagamentoDebidoEmConta,
  LIST: FORMA_PAGAMENTO_LIST,
});

export default FormaPagamentoUtils;
